<template lang="pug">
  nav.ui-navbar.navbar(role="navigation" :class="{'is-fixed-top':fixed}")
    .navbar-brand
      .navbar-item
        .is-hidden-touch
          strong Медред CRM
          div {{ user.isSupport ? 'Контрольная панель' : 'Техподдержка' }}
      router-link.navbar-item(v-for="item in menu" :to="{name: item.route}" :key="item.route" @click.native="menuActive=false")
        b-icon(:icon="item.icon")
        span.ml-5.is-hidden-touch(v-if="item.title") {{ item.title }}

      a.navbar-burger(:class="activeClass" role="button" @click="menuActive=!menuActive")
        span(aria-hidden="true")
        span(aria-hidden="true")
        span(aria-hidden="true")

    .navbar-menu(:class="activeClass")
      //.navbar-start
        router-link.navbar-item(v-for="item in menu" :to="{name: item.route}" :key="item.route" @click.native="menuActive=false")
          b-icon.mr-5(:icon="item.icon")
          span(v-if="item.title") {{ item.title }}

      .navbar-end
        b-dropdown.navbar-item(position="is-bottom-left")
          button.button.is-white.is-rounded(slot="trigger")
            user-name(:user="user")
            b-icon(icon="menu-down")
          //- b-dropdown-item Профиль
          //- b-dropdown-item(separator)
          b-dropdown-item(@click="$emit('logout')")
            b-icon(icon="logout" size="is-small")
            span Выйти
</template>

<script>
const updateHtmlClass = (fixed, addClass) => {
  if (fixed) {
    document.getElementsByTagName('html')[0].className = addClass ? 'has-navbar-fixed-top' : '';
  }
};

export default {
  name: 'ui-navbar',

  props: {
    fixed: Boolean,
    user: Object,
    menu: [Object, Array],
  },

  data: () => ({
    menuActive: false,
  }),

  computed: {
    activeClass() {
      return this.menuActive ? 'is-active' : '';
    },
  },

  methods: {
    closeMenu() {
      this.menuActive = false;
    },
  },
  created() {
    updateHtmlClass(this.fixed, true);
  },

  destroyed() {
    updateHtmlClass(this.fixed, false);
  },
};
</script>
